import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CtrlService {

  constructor() { }
}










import { PopoverController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class PopoverService {
  
  constructor(
    public popCtrl: PopoverController
  ) {
  }
  
  async ctrl(view: any, ev?: any) {
    view.componentProps = {
      ...view.componentProps,
      ...(view.items)?{items: view.items}:null,
      ctrl: this.popCtrl
    }
    view.translucent = view.translucent || false;
    view.event = view.event || ev;
    return await this.popCtrl.create(view);
  } 
  
  async show(view: any, ev?: any) {
    const popover = await this.ctrl(view, ev);
    await popover.present();
    let r = await popover[view.then || 'onDidDismiss']();
    return r.data;
  }
    
}










import { ModalController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  
  constructor(
    public modalCtrl: ModalController
  ) {
  }
  
  async ctrl(view: any, ev?: any) {
    view.componentProps = {
      ...view.componentProps,
      ...(view.items)?{items: view.items}:null,
      ctrl: this.modalCtrl
    }
    view.translucent = view.translucent || false;
    view.event = view.event || ev;
    return await this.modalCtrl.create(view);
  } 
  
  async show(view: any, ev?: any) {
    const modal = await this.ctrl(view, ev);
    await modal.present();
    let r = await modal[view.then || 'onDidDismiss']();
    return r.data;
  }
    
}
